import React from 'react';

import '../styles/checkbox.scss';
type CheckboxProps = {
  checked: boolean;
  onChange: () => void;
  label: string;
  id: string;
};

const Checkbox: React.FC<CheckboxProps> = ({
  checked,
  onChange,
  label,
  id,
}) => {
  return (
    <div className={'checkbox'}>
      <input
        className={'checkbox__input'}
        type="checkbox"
        id={id}
        checked={checked}
        onChange={() => onChange()}
      />
      <label className={'checkbox__label'} htmlFor={id}>
        {label}
      </label>
    </div>
  );
};

export default Checkbox;
